import styled from "styled-components";

export const PdfWrapperDiv = styled.div`
  position: relative;
`;

export const PdfFillerDiv = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 800px;
  overflow-y: hidden;
  & > p {
    font-size: 100%;
    line-height: 100%;
    width: 100%;
    margin: 0;
    letter-spacing: 1.5px;
    text-align: justify;
    -moz-text-align-last: justify;
    text-align-last: justify;
    color: transparent;
  }
`;

export const PdfLeftRightDivDiv = styled.div`
  display: flex;
  & > div + div {
    margin-left: var(--outerMargin);
    & h3 {
      margin: 0;
    }
  }
`;
